import { defineStore, storeToRefs } from "pinia";
import { useFetch } from "@/helpers/composables/useFetch";
import { computed, ref, inject } from "vue";
export const useFavoritesStore = defineStore('favorites', ()=>{
    const route = inject('route');
    console.log('initializing favorites...');
    const {data, execute} = useFetch(route('endpoint.favorites.index'), { immediate: false, afterFetch(ctx){
        newFavorites.value = [];
        return ctx;
    }}).get().json();

    function getFavorites(){
        execute();
    }
   

    const favorites = computed(()=>{
        if(data.value){
            let arr = data.value.data;
            arr.push(...newFavorites.value);
            return arr;
        }
        return newFavorites.value;
    });

    let newFavorites = ref([]);

    let pushNewFavorite = (favorite: Object)=>{
        newFavorites.value.push(favorite);
    }

    let hasFavorites = computed(()=>{
        return favorites.value.length > 0;
    })
    return {
        favorites,
        pushNewFavorite,
        getFavorites,
        newFavorites,
        hasFavorites
    }
})

export function createUseFavoritesStore(storeName: string, fav: Object, afterDelete?: Function,){
    return defineStore(storeName, ()=>{
        const route = inject('route');
        let favoriteStore = useFavoritesStore();
        let {favorites} = storeToRefs(favoriteStore);
        let favorite = ref(fav);
        let favoriteId = computed(()=>{
            if(favorites?.value?.length > 0){
                return favorites.value.find(favo => favo.item_index == favorite.value.item_index)?.favorite_id;
            }else if(favorite.value.favorite_id){
                return favorite.value.favorite_id;
            }
            return 0;
        });
        const { data: postResponse, execute: addFavorite } = useFetch(route('endpoint.favorites.store'), {immediate: false, 
            afterFetch(ctx){
                favoriteStore.pushNewFavorite(ctx.data);
                favorite.value = ctx.data;
                favoriteStore.getFavorites();
                return ctx;
            }
        }).post({
            favorite: favorite.value
        }).json();
        const destroyRoute = computed(()=>{
            if(favoriteId.value == null){
                return '';
            }
            return route('endpoint.favorites.destroy', favoriteId.value);
        });
        const { execute: deleteFavorite } = useFetch(destroyRoute, {
            immediate: false,
            afterFetch(ctx){
                console.log('deleted');
                favorite.value.favorite_id = null;
                favoriteStore.getFavorites();
            }
        }).delete().json();
        return {
            favoriteId,
            favorite,
            addFavorite,
            deleteFavorite,
        }
    });
}